import React from 'react'

import { Badge, PriceSubscription } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'
import MenuItem from 'Pods/UnifiedNavigation/Shared/MenuItem/MenuItem'
import Section from 'Pods/UnifiedNavigation/Shared/Section/Section'

// Subscription entry with the "NEW" badge. The parent gates this on
// subscriptionMenuEnabled.
function SubscriptionSection({ locale = 'en' }) {
  const t = (key) => i18n.t(key, { ns: 'rails', lng: locale })

  return (
    <Section divided>
      <MenuItem
        title={t('navigation.user_menu.seller.subscription')}
        url="/profile/subscription"
        svgComponent={PriceSubscription}
        dataName="Subscription"
      >
        <Badge type="positive">NEW</Badge>
      </MenuItem>
    </Section>
  )
}

SubscriptionSection.propTypes = {
  locale: string,
}

export default SubscriptionSection
